import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ClinicLocationService } from '../services/clinic-location.service';

/**
 * Fetches the paginated patient list for a clinic location (doctor/provider view).
 *
 * The `query` is the already-stringified query string (limit/offset/order/filters) so that it
 * doubles as the cache key — passing the same query returns cached data.
 *
 * Pass `enabled` to gate the request until sorting params are initialised (mirrors the legacy
 * "load with default sort" behaviour).
 */
export function useClinicLocationPatients(
  clinicLocationId: string | undefined,
  query: string,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ['clinic-location-patients', clinicLocationId, query],
    queryFn: () =>
      ClinicLocationService.getClinicLocationPatients(query, clinicLocationId),
    enabled: !!clinicLocationId && enabled,
    placeholderData: keepPreviousData,
    retry: 3,
  });
}
